"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const styled_components_1 = __importDefault(require("styled-components"));

const StyledTabContent = styled_components_1.default.div`
  background-color: ${props => props.bgColor || props.theme.colors.white};
  box-shadow: ${props => props.bgColor && '0px 0px 5px #0000001A'};
`;

const TabContent = props => {
  return (0, jsx_runtime_1.jsx)(StyledTabContent, Object.assign({
    bgColor: props.bgColor
  }, {
    children: props.children
  }), void 0);
};

exports.default = TabContent;